import React from 'react';
import { clsx } from 'clsx';

interface TableHeaderCellProps extends React.ThHTMLAttributes<HTMLTableHeaderCellElement> {
  children: React.ReactNode;
}

export function TableHeaderCell({ children, className, ...props }: TableHeaderCellProps) {
  return (
    <th 
      className={clsx(
        "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider", 
        className
      )} 
      {...props}
    >
      {children}
    </th>
  );
} 